var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Ticker {
  constructor(type = "fixed", targetFPS = -1) {
    __publicField(this, "_started", false);
    __publicField(this, "_lastTime", 0);
    __publicField(this, "_lastFrame", 0);
    __publicField(this, "_tickerId", 0);
    __publicField(this, "_tickers", /* @__PURE__ */ new Map());
    __publicField(this, "_type");
    __publicField(this, "_targetFPS", 60);
    __publicField(this, "_maxElapsedMS", 100);
    __publicField(this, "_minElapsedMS", 0);
    __publicField(this, "lastTime", 0);
    __publicField(this, "_tick");
    __publicField(this, "_requestId", null);
    __publicField(this, "update", (currentTime) => {
      let elapsedMS;
      if (currentTime > 0) {
        elapsedMS = currentTime - this._lastTime;
        if (elapsedMS < 1e3 / 90) {
          return;
        }
        if (elapsedMS > this._maxElapsedMS) {
          elapsedMS = this._maxElapsedMS;
        }
        if (this._minElapsedMS && this._type === "fixed") {
          const delta = currentTime - this._lastFrame | 0;
          if (delta < this._minElapsedMS) {
            return;
          }
          elapsedMS = this._minElapsedMS;
          this._lastFrame = currentTime - delta % this._minElapsedMS;
        }
        this._tickers.forEach((ticker) => {
          ticker(elapsedMS);
        });
        this._lastTime = currentTime;
      }
    });
    this._type = type;
    if (targetFPS > 0) {
      this._minElapsedMS = 1e3 / targetFPS;
    }
    this._tick = (time) => {
      this._requestId = null;
      if (this._started) {
        this.update(time);
        if (this._started && this._requestId === null && this._tickers.size > 0) {
          this._requestId = requestAnimationFrame(this._tick);
        }
      }
    };
  }
  _requestIfNeeded() {
    if (this._requestId === null && this._tickers.size > 0) {
      this._lastTime = performance.now();
      this._lastFrame = this._lastTime;
      this._requestId = requestAnimationFrame(this._tick);
    }
  }
  _cancelIfNeeded() {
    if (this._requestId !== null) {
      cancelAnimationFrame(this._requestId);
      this._requestId = null;
    }
  }
  start() {
    this._started = true;
    this._requestIfNeeded();
  }
  stop() {
    this._started = false;
    this._cancelIfNeeded();
  }
  add(ticker) {
    const id = ++this._tickerId;
    this._tickers.set(id, ticker);
    return id;
  }
  remove(id) {
    this._tickers.delete(id);
  }
}
export {
  Ticker as default
};
//# sourceMappingURL=Ticker.js.map
